import { adapter, initialState } from './device-sync-status.state';
import { createReducer, on } from '@ngrx/store';
import { DeviceSyncStatusApiActions, SignalRActions } from './device-sync-status.actions';

export const deviceSyncStatusFeatureKey = 'deviceSyncStatuses';

export const DeviceSyncStatusReducer = createReducer(
  initialState,
  on(DeviceSyncStatusApiActions.syncStatusesLoaded, (state, { statuses }) => adapter.upsertMany(statuses, state)),
  on(SignalRActions.statusChanged, (state, { status }) => adapter.upsertOne(status, state))
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectDeviceSyncStatusIds = selectIds;

export const selectDeviceSyncStatusEntities = selectEntities;

export const selectDeviceSyncStatuses = selectAll;
